import React from 'react';
import { Button, Space } from 'antd';
import { FormattedMessage } from 'react-intl';

interface Props {
  daysLeft?: number;
  handleClick: () => void;
  isAccountActive?: boolean;
  isContractAccepted?: boolean;
}

const TrialBanner: React.FC<Props> = ({
  daysLeft,
  handleClick,
  isAccountActive,
  isContractAccepted,
}) => (
  <Space size="middle">
    <span css="white-space: nowrap">
      {isAccountActive === false && (
        <FormattedMessage defaultMessage="Your account has expired" />
      )}

      {daysLeft === 0 && (
        <FormattedMessage defaultMessage="Your trial ends today" />
      )}
      {daysLeft !== undefined && daysLeft > 0 && (
        <FormattedMessage
          defaultMessage="Your trial ends in {days, plural, one {# day} other{# days}}"
          values={{ days: daysLeft }}
        />
      )}
    </span>

    {!isContractAccepted && (
      <Button
        type="default"
        css={`
          color: #0099ff;
          border-color: #0099ff;
        `}
        onClick={handleClick}
      >
        <FormattedMessage defaultMessage="Activate now" />
      </Button>
    )}
  </Space>
);

export default TrialBanner;
